const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      'div',
      [
        _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
          _vm._v('Notification')
        ]),
        _c('p', { staticClass: 'uk-text-lead' }, [
          _vm._v('Create toggleable notifications that fade out automatically.')
        ]),
        _vm._v(' '),
        _vm._m(0),
        _c('p', [
          _vm._v(
            'The notification will not fade out but remain visible when you hover the message until you stop hovering. You can also close the notification by clicking it. To show notifications simply push them in your array messages data, as simple text or Object. The following code snippet gets you started.'
          )
        ]),
        _vm._v(' '),
        _vm._m(1),
        _c('md-code-example-78'),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(
              ' By default identical messages displayed at the same time will be ignored. In the demo we are changing the message text but you can as well set a unique '
            ),
            _c('code', [_vm._v('key')]),
            _vm._v(' to the message '),
            _c('code', [_vm._v('Object')]),
            _vm._v(' and display messages with the exact same text.')
          ],
          1
        ),
        _vm._v(' '),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(2),
        _c('p', [
          _vm._v(
            'You can set custom HTML inside your messages using the default scoped slot.'
          )
        ]),
        _vm._v(' '),
        _vm._m(3),
        _c('md-code-example-79'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(4),
        _vm._m(5),
        _vm._v(' '),
        _vm._m(6),
        _vm._m(7),
        _c('md-code-example-80'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(8),
        _vm._m(9),
        _vm._v(' '),
        _vm._m(10),
        _c('md-code-example-81'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(11),
        _vm._m(12),
        _vm._m(13),
        _vm._m(14),
        _vm._m(15)
      ],
      1
    )
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
        [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v(':messages')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"[{...}]"')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'html-message' }
        },
        [
          _c('a', { attrs: { href: '#html-message' } }, [
            _vm._v('HTML message')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('slot-scope')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"{ message }"')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n    '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-icon')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-icon')]),
              _vm._v('>')
            ]),
            _vm._v(' '),
            _c('span', [_vm._v('{{')]),
            _vm._v(' message '),
            _c('span', [_vm._v('}}')]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'position' } },
        [_c('a', { attrs: { href: '#position' } }, [_vm._v('Position')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Add one of the following options to the '),
        _c('code', [_vm._v('position')]),
        _vm._v(
          " prop to adjust the notification's position to different corners."
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('position')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"top-right"')
              ]),
              _vm._v('>')
            ]),
            _vm._v('...'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Position')
              ]),
              _vm._v(' '),
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Code')
              ])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('top-left')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="top-left"')])
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('top-center')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="top-center"')])
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('top-right')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="top-right"')])
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottom-left')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="bottom-left"')])
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottom-center')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="bottom-center"')])
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottom-right')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('position="bottom-right"')])
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'style' } },
        [_c('a', { attrs: { href: '#style' } }, [_vm._v('Style')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'A notification can be styled by adding a status to the message to indicate a '
        ),
        _c('code', [_vm._v('primary')]),
        _vm._v(', '),
        _c('code', [_vm._v('success')]),
        _vm._v(', '),
        _c('code', [_vm._v('warning')]),
        _vm._v(' or '),
        _c('code', [_vm._v('danger')]),
        _vm._v(' status.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('status')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"primary"')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-notification')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'props' } },
        [_c('a', { attrs: { href: '#props' } }, [_vm._v('Props')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'vk-notification' }
        },
        [
          _c('a', { attrs: { href: '#vk-notification' } }, [
            _vm._v('vk-notification')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('timeout')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('5000')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Time after which the message will be auto-closed.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('status')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('The message status style with '),
                _c('code', [_vm._v('primary')]),
                _vm._v(', '),
                _c('code', [_vm._v('success')]),
                _vm._v(', '),
                _c('code', [_vm._v('warning')]),
                _vm._v(' or '),
                _c('code', [_vm._v('danger')]),
                _vm._v(' as possible options.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('position')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('top-center')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v('The position corner where to display the message - '),
                _c('code', [_vm._v('(top bottom)-(left center right)')]),
                _vm._v('.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('messages')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Array')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('[]')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Array of '),
                _c('code', [_vm._v('String')]),
                _vm._v(' or '),
                _c('code', [_vm._v('Object')]),
                _vm._v(' representing the message to display.')
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        {
          staticClass: 'uk-h3 tm-heading-fragment',
          attrs: { id: 'the-message-object' }
        },
        [
          _c('a', { attrs: { href: '#the-message-object' } }, [
            _vm._v('The message Object')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('key')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('A unique '),
                _c('code', [_vm._v('key')]),
                _vm._v(
                  ' to allow identifying the message over others when they are sharing the same exact text and display options.'
                )
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('timeout')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Overrides the '),
                _c('code', [_vm._v('vk-notification')]),
                _vm._v(' timeout.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('status')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Overrides the '),
                _c('code', [_vm._v('vk-notification')]),
                _vm._v(' status.')
              ])
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'usage', title: 'Usage' },
    { id: 'html-message', title: 'HTML message' },
    { id: 'position', title: 'Position' },
    { id: 'style', title: 'Style' },
    { id: 'props', title: 'Props' }
  ],
  components: {
    'md-code-example-78': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c('vk-notification', {
                      attrs: { messages: _vm.messages },
                      on: {
                        'update:messages': function($event) {
                          _vm.messages = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c(
                      'vk-button',
                      {
                        on: {
                          click: function($event) {
                            _vm.count++,
                              _vm.messages.push('Message ' + _vm.count)
                          }
                        }
                      },
                      [_vm._v('Simple message')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '78' } },
                      [
                        _vm._v('---\ncount: 0\nmessages: []\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"messages"')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v(
                              '"count++, messages.push(`Message ${count}`)"'
                            )
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Simple message'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { count: 0, messages: [] }
      }
    },
    'md-code-example-79': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c('vk-notification', {
                      attrs: { messages: _vm.messages },
                      on: {
                        'update:messages': function($event) {
                          _vm.messages = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: 'default',
                          fn: function(ref) {
                            var message = ref.message
                            return _c(
                              'div',
                              {},
                              [
                                _c('vk-icon', { attrs: { icon: 'check' } }),
                                _vm._v(' ' + _vm._s(message) + '\n  ')
                              ],
                              1
                            )
                          }
                        }
                      ])
                    }),
                    _vm._v(' '),
                    _c(
                      'vk-button',
                      {
                        on: {
                          click: function($event) {
                            _vm.messages.push('Message')
                          }
                        }
                      },
                      [_vm._v('Click me')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '79' } },
                      [
                        _vm._v('---\nmessages: []\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"messages"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('div')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('slot-scope')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"{ message }"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n    '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-icon')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('icon')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"check"')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-icon')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v(' '),
                        _c('span', [_vm._v('{{')]),
                        _vm._v(' message '),
                        _c('span', [_vm._v('}}')]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('div')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"messages.push(\'Message\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Click me'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { messages: [] }
      }
    },
    'md-code-example-80': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c('vk-notification', {
                      attrs: { position: 'top-left', messages: _vm.topLeft },
                      on: {
                        'update:messages': function($event) {
                          _vm.topLeft = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c('vk-notification', {
                      attrs: {
                        position: 'top-center',
                        messages: _vm.topCenter
                      },
                      on: {
                        'update:messages': function($event) {
                          _vm.topCenter = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c('vk-notification', {
                      attrs: { position: 'top-right', messages: _vm.topRight },
                      on: {
                        'update:messages': function($event) {
                          _vm.topRight = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c('vk-notification', {
                      attrs: {
                        position: 'bottom-left',
                        messages: _vm.bottomLeft
                      },
                      on: {
                        'update:messages': function($event) {
                          _vm.bottomLeft = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c('vk-notification', {
                      attrs: {
                        position: 'bottom-center',
                        messages: _vm.bottomCenter
                      },
                      on: {
                        'update:messages': function($event) {
                          _vm.bottomCenter = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c('vk-notification', {
                      attrs: {
                        position: 'bottom-right',
                        messages: _vm.bottomRight
                      },
                      on: {
                        'update:messages': function($event) {
                          _vm.bottomRight = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c(
                      'p',
                      {
                        directives: [
                          { name: 'vk-margin', rawName: 'v-vk-margin' }
                        ]
                      },
                      [
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.topLeft.push('Top Left...')
                              }
                            }
                          },
                          [_vm._v('Top Left')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.topCenter.push('Top Center...')
                              }
                            }
                          },
                          [_vm._v('Top Center')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.topRight.push('Top Right...')
                              }
                            }
                          },
                          [_vm._v('Top Right')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.bottomLeft.push('Bottom Left...')
                              }
                            }
                          },
                          [_vm._v('Bottom Left')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.bottomCenter.push('Bottom Center...')
                              }
                            }
                          },
                          [_vm._v('Bottom Center')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.bottomRight.push('Bottom Right...')
                              }
                            }
                          },
                          [_vm._v('Bottom Right')]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '80' } },
                      [
                        _vm._v(
                          '---\ntopLeft: []\ntopCenter: []\ntopRight: []\nbottomLeft: []\nbottomCenter: []\nbottomRight: []\n---\n\n'
                        ),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"top-left"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topLeft"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"top-center"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topCenter"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"top-right"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topRight"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottom-left"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomLeft"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottom-center"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomCenter"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('position')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottom-right"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomRight"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-margin')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topLeft.push(\'Top Left...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top Left'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topCenter.push(\'Top Center...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top Center'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"topRight.push(\'Top Right...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top Right'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomLeft.push(\'Bottom Left...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom Left'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomCenter.push(\'Bottom Center...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom Center'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"bottomRight.push(\'Bottom Right...\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom Right'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {
          topLeft: [],
          topCenter: [],
          topRight: [],
          bottomLeft: [],
          bottomCenter: [],
          bottomRight: []
        }
      }
    },
    'md-code-example-81': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c('vk-notification', {
                      attrs: { status: 'primary', messages: _vm.messages },
                      on: {
                        'update:messages': function($event) {
                          _vm.messages = $event
                        }
                      }
                    }),
                    _vm._v(' '),
                    _c(
                      'p',
                      {
                        directives: [
                          { name: 'vk-margin', rawName: 'v-vk-margin' }
                        ]
                      },
                      [
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.messages.push('Primary')
                              }
                            }
                          },
                          [_vm._v('Primary')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.messages.push({
                                  message: 'Success',
                                  status: 'success'
                                })
                              }
                            }
                          },
                          [_vm._v('Success')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.messages.push({
                                  message: 'Warning',
                                  status: 'warning'
                                })
                              }
                            }
                          },
                          [_vm._v('Warning')]
                        ),
                        _vm._v(' '),
                        _c(
                          'vk-button',
                          {
                            on: {
                              click: function($event) {
                                _vm.messages.push({
                                  message: 'Danger',
                                  status: 'danger'
                                })
                              }
                            }
                          },
                          [_vm._v('Danger')]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '81' } },
                      [
                        _vm._v('---\nmessages: []\n---\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('status')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"primary"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v(':messages.sync')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"messages"')
                          ]),
                          _vm._v('>')
                        ]),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-notification')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-margin')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"messages.push(\'Primary\')"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Primary'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v(
                              "\"messages.push({ message: 'Success', status: 'success' })\""
                            )
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Success'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v(
                              "\"messages.push({ message: 'Warning', status: 'warning' })\""
                            )
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Warning'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('click')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v(
                              "\"messages.push({ message: 'Danger', status: 'danger' })\""
                            )
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Danger'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { messages: [] }
      }
    }
  }
}


export default Component
